import React from "react";
import { FaBagShopping } from "react-icons/fa6";
import { MdCurrencyRupee } from "react-icons/md";
import { HiBanknotes } from "react-icons/hi2";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { Tooltip } from "react-tooltip";
import "./MerchantDashboard.css";

const Firstsection = ({ payInStatistic, payoutStatistic }) => {

  const payInData = payInStatistic?.payIn || {};
  const payoutData = payoutStatistic?.payout || {};

  const payoutNet = payoutData.payoutSettlementAmount && payoutData.payoutOutProcessing
  ? (payoutData.payoutSettlementAmount - payoutData.payoutOutProcessing).toFixed(2)
  : "0";
    

  return (
    <div className="first-section">
      <div className="left-section-new">
        <div className="left-section-2">
          <div className="new-section">
            <div className="data-icon-box">
              <p className="heading-new">Total Payin Volume</p>
              <IoMdInformationCircleOutline className="my-anchor-element1" style={{ color: "#878a99" }} />
              <Tooltip anchorSelect=".my-anchor-element1" place="top" className="custom-reduce">
                Total Number Of Payin Transactions
              </Tooltip>
            </div>
            <div className="data-icon-box">
              <p className="sub-heading-new">{payInData.payInTotal || "0"}</p>
              <div className="icon-div">
                <FaBagShopping style={{ width: "1rem", height: "1rem", color: "white" }} />
              </div>
            </div>
          </div>

          <div className="new-section">
            <div className="data-icon-box">
              <p className="heading-new">Total Deposits</p>
              <IoMdInformationCircleOutline className="my-anchor-element" style={{ color: "#878a99" }} />
              <Tooltip anchorSelect=".my-anchor-element" place="top" className="custom-reduce">
                Total Payin Amount Without Commission And Rolling Reserve
              </Tooltip>
            </div>
            <div className="data-icon-box">
              <p className="sub-heading-new">
              ₹ {Number(payInData?.payinAmount).toFixed(2) || "0.00"}
              </p>
              <div className="icon-div">
                <MdCurrencyRupee style={{ width: "1rem", height: "1rem", color: "white" }} />
              </div>
            </div>
          </div>

          <div className="new-section">
            <div className="data-icon-box">
              <p className="heading-new">Net Payin Amount</p>
              <IoMdInformationCircleOutline className="my-anchor-element2" style={{ color: "#878a99" }} />
              <Tooltip anchorSelect=".my-anchor-element2" place="top" className="custom-reduce">
                Payin After Commission and Rolling Reserve is Deducted
              </Tooltip>
            </div>
            <div className="data-icon-box">
              <p className="sub-heading-new">
              ₹ {payInData.payinSettlementAmount?.toFixed(2) || "0.00"}
              </p>
              <div className="icon-div">
                <HiBanknotes style={{ width: "1rem", height: "1rem", color: "white" }} />
              </div>
            </div>
          </div>

          <div className="new-section">
            <div className="data-icon-box">
              <p className="heading-new">Total Payout Volume</p>
              <IoMdInformationCircleOutline className="my-anchor-element4" style={{ color: "#878a99" }} />
              <Tooltip anchorSelect=".my-anchor-element4" place="top" className="custom-reduce">
                Total Number Of Payout Transactions
              </Tooltip>
            </div>
            <div className="data-icon-box">
              <p className="sub-heading-new">{payoutData?.payOutTotal || "0"}</p>
              <div className="icon-div">
                <FaBagShopping style={{ width: "1rem", height: "1rem", color: "white" }} />
              </div>
            </div>
          </div>


          <div className="new-section">
            <div className="data-icon-box">
              <p className="heading-new">Total Withdrawal</p>
              <IoMdInformationCircleOutline className="my-anchor-element" style={{ color: "#878a99" }} />
              <Tooltip anchorSelect=".my-anchor-element" place="top" className="custom-reduce">
                Total Payout Amount Without Commission
              </Tooltip>
            </div>
            <div className="data-icon-box">
              <p className="sub-heading-new">
                {/* ₹ {payInStatistic?.payinAmount ? payInStatistic.payinAmount.toFixed(2) : "0"} */}

                ₹ {Number(payoutData?.payoutAmount).toFixed(2) || "0.00"}
              </p>
              <div className="icon-div">
                <MdCurrencyRupee style={{ width: "1rem", height: "1rem", color: "white" }} />
              </div>
            </div>
          </div>

          <div className="new-section">
            <div className="data-icon-box">
              <p className="heading-new">Net Payout Amount</p>
              <IoMdInformationCircleOutline className="my-anchor-element6" style={{ color: "#878a99" }} />
              <Tooltip anchorSelect=".my-anchor-element6" place="top" className="custom-reduce">
                Payout with Commission Added
              </Tooltip>
            </div>
            <div className="data-icon-box">
              <p className="sub-heading-new">₹ {Number(payoutData?.payoutSettlementAmount).toFixed(2) || "0.00"}</p>
              <div className="icon-div">
                <HiBanknotes style={{ width: "1rem", height: "1rem", color: "white" }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <div className="new-section-1">
        <div className="comm-side">
          <p className="heading-new">Total Commission</p>
          <p className="sub-heading-new">
            ₹  {(Number(payInData.payinTotalComission || 0) +
              (payoutData.payoutTotalComission || 0)).toFixed(2)}
          </p>
        </div>

        <div className="comm-side">
          <p className="heading-new">Commission For Payin</p>
          <p className="sub-heading-new">₹  {Number(payInData.payinTotalComission || "0").toFixed(2)}</p>
        </div>

        <div className="comm-side">
          <p className="heading-new">Commission For Payout</p>
          <p className="sub-heading-new">₹ 
              {Number(payoutData?.payoutTotalComission || "0").toFixed(2)}</p>
        </div>
      </div>
    </div>
  );
};

export default Firstsection;
